import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";

export default function CryptoLicensePanama() {

    return (
        <main className='main'>

            <IntroSection
                title="Build Your Crypto Exchange or Wallet Business in Panama"
                subtitle="Build Your Crypto Exchange or Wallet Business in Panama"
                description="
                <b>Panama</b> is one of the <b>most progressive digital asset jurisdictions</b> in <b>Latin America</b>. Under <b>Law No. 697 (2022)</b>, <b>crypto firms</b> can register as <b>Crypto Asset Service Providers (CASPs)</b> with the <b>Intendencia de Supervisión y Regulación de Sujetos No Financieros (ISR-SNF)</b>.
                With its <b>territorial tax regime (no tax on foreign-sourced income)</b>, <b>pro-crypto stance</b>, and <b>strategic LatAm location</b>, <b>Panama</b> is becoming a <b>popular choice</b> for <b>crypto exchanges</b>, <b>wallet providers</b>, <b>token projects</b>, and <b>hybrid payment platforms</b>.
                "
                badges={
                    [
                        "Crypto Exchange",
                        "Wallet & Custody",
                        "Token Issuance",
                        "Crypto PSPs"
                    ]
                }
                buttonText="Request a Panama Crypto Proposal "
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/crypto-license-panama-hero.png")}
                imageAlt=""
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title='Why Choose Panama for Crypto?'
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            title: "Pro-Crypto Regulation",
                                            text: "Law 697 recognizes digital assets."
                                        },
                                        {
                                            title: "Light Compliance",
                                            text: "Fewer barriers than EU, US, or Singapore."
                                        },
                                        {
                                            title: "No Heavy Capital Requirement",
                                            text: "Startups can enter more easily."
                                        },
                                        {
                                            title: "Tax-Friendly",
                                            text: "Foreign-sourced crypto income exempt from tax."
                                        },
                                        {
                                            title: "Strategic Gateway",
                                            text: "Connects LatAm with global crypto markets."
                                        }
                                    ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Activities Covered Under Panama’s Crypto Law"
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Operating crypto exchanges (spot, OTC, P2P)."
                                    },
                                    {
                                        text: "Providing custody & wallet services."
                                    },
                                    {
                                        text: "Issuing tokens, ICOs, STOs, and IEOs."
                                    },
                                    {
                                        text: "Offering crypto-to-fiat gateways & payment integrations."
                                    },
                                    {
                                        text: "Running DeFi and blockchain-based platforms."
                                    },
                                    {
                                        text: "Managing NFT marketplaces & tokenized assets."
                                    }
                                ]

                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Capital & Compliance"
                        item={
                            [
                                {
                                    title: "Capital Requirement",
                                    text: "None fixed by law (flexible case-by-case)."
                                },
                                {
                                    title: "Local Presence",
                                    text: "Panama entity required."
                                },
                                {
                                    title: "Compliance",
                                    text: "AML/KYC framework in line with FATF."
                                },
                                {
                                    title: "Ongoing",
                                    text: "Annual audits and ISR-SNF reporting."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Benefits of a Panama Crypto License'
                        services={
                            [
                                {
                                    title: "Global Flexibility",
                                    text: "Recognized as pro-crypto jurisdiction."
                                },
                                {
                                    title: "Low Entry Barriers",
                                    text: "No fixed capital minimums."
                                },
                                {
                                    title: "Banking Access",
                                    text: "Possible through Panama’s large banking hub."
                                },
                                {
                                    title: "Investor-Friendly",
                                    text: "Attracts fintechs and token projects."
                                },
                                {
                                    title: "Crypto + Payments Hybrid",
                                    text: "Integrate with Panama’s MSB/fintech regime."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Consultation & Structuring",
                                    text: "Define crypto activities (exchange, wallet, token, PSP)."
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Register Panama entity."
                                },
                                {
                                    title: "Application Preparation",
                                    text: "AML/KYC manuals, business plan."
                                },
                                {
                                    title: "Submission to ISR-SNF",
                                    text: "Registration as a CASP."
                                },
                                {
                                    title: "Approval & Registration",
                                    text: "Typically 3–6 months."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "Timeline",
                                    duration: "3–6 months.",
                                },
                                {
                                    name: "Setup Costs",
                                    description: " from USD 40,000+ (legal, compliance, advisory)."
                                },
                                {
                                    name: "Capital Requirement",
                                    description: "None fixed (flexible)."
                                },
                                {
                                    name: "Annual Costs",
                                    description: "compliance, reporting, audits."
                                },
                            ]
                        }
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={[
                            {
                                text: "Specialists in Panama crypto licensing & fintech structuring."
                            },
                            {
                                text: "End-to-end service: company setup, license registration, compliance manuals."
                            },
                            {
                                text: "Introductions to crypto-friendly banks & PSPs."
                            },
                            {
                                text: "Guidance on token offerings, wallets, and payment integrations."
                            },
                            {
                                text: "Comparison: Panama vs EU (Malta, Cyprus) vs Offshore (Anjouan, Mwali, Western Sahara)."
                            }
                        ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to launch a regulated crypto business in Latin America?"
                        description="Panama offers crypto licensing under Law 697, with low barriers, tax advantages, and global flexibility."
                        buttonText="Book a Panama Crypto License Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Does Panama fully license crypto exchanges?",
        content: [
            { type: "answer", text: "Yes — under Law 697, exchanges can register as CASPs with ISR-SNF." },
        ],
    },
    {
        question: "Is there a capital requirement?",
        content: [
            { type: "answer", text: "No fixed requirement — flexible case-by-case." },
        ],
    },
    {
        question: "How long does registration take?",
        content: [
            { type: "answer", text: "Around 3–6 months." },
        ],
    },
    {
        question: "Can I issue tokens or run an ICO/STO in Panama?",
        content: [
            { type: "answer", text: "Yes — token offerings are permitted under the crypto law." },
        ],
    },
    {
        question: "How does Panama compare to Malta or Cyprus?",
        content: [
            { type: "answer", text: "Panama is faster and cheaper, but Malta/Cyprus provide Tier-1 EU recognition." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "We registered our crypto exchange in Panama. Offshore Advisory guided us through compliance and ISR-SNF registration.",
            author: "Diego R.",
            role: "Exchange Founder"
        },
        {
            quote: "Panama gave us the flexibility to launch a hybrid PSP + crypto wallet platform. Offshore Advisory managed the full licensing process.",
            author: "Sofia M.",
            role: "FinTech Entrepreneur"
        }
    ]
;